// components/features/tickets/TicketList.tsx

import { Ticket } from '../../../types/features/Ticket';
import TableList, { SelectAction } from '../../ui/TableList';
import TicketRow from './TicketRow';

interface TicketListProps {
  tickets: Ticket[];
  onAction: (ticket: Ticket) => void;
  onSelectTickets?: (selectedTickets: Ticket[]) => void;
  selectable?: boolean;
  selectActions?: SelectAction[];
}

export default function TicketList({
  tickets,
  onAction,
  onSelectTickets,
  selectable = false,
  selectActions
}: TicketListProps) {
  const columns = [
    { header: "Ticket", className: "w-2/5" },
    { header: "Priorité", className: "hidden sm:table-cell w-1/6" },
    { header: "Statut", className: "hidden md:table-cell w-1/6" },
    { header: "Source", className: "hidden lg:table-cell w-1/6" },
    { header: "Date", className: "hidden xl:table-cell w-1/6" },
  ];

  return (
    <TableList
      items={tickets}
      columns={columns}
      getId={(ticket) => ticket.id}
      onAction={onAction}
      onSelectItems={onSelectTickets}
      selectable={selectable}
      emptyMessage="Aucun ticket trouvé"
      actionColumn={true}
      selectActions={selectActions}
      renderRow={(ticket, isSelected, onSelect) => (
        <TicketRow
          key={ticket.id}
          ticket={ticket}
          onAction={onAction}
          onSelect={onSelect}
          isSelected={isSelected}
          selectable={selectable}
        />
      )}
    />
  );
}